<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          @click="openCreateModal"
        >
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
          Nouveau Utilisateur
        </button>
        <!-- <button
          class="default-outline-btn position-relative transition fw-medium text-black pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 bg-transparent fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0"
          type="button"
        >
          Export
          <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
        </button> -->
      </div>
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search "
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <div v-else-if="props.column.field == 'name'">
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center ms-5 fs-md-15 fs-lg-16">
                <img
                v-if="props.row.image"
                  :src="props.row.image"
                  class="rounded-circle me-8"
                  width="24"
                  height="24"
                />
                <img v-else
                  :src="require('@/assets/images/NoImage.png')"
                  class="rounded-circle me-8"
                  width="24"
                  height="24"
                />
                {{ props.row.name }}<br />
                <small class="text-muted">{{ props.row.email }}</small>
              </div>
            </div>
          </div>

          <span v-else-if="props.column.field == 'actions'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="openEditModal(props.row)"
                  >
                    <i
                      class="flaticon-pen lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </a>
                </li> -->

                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="destroyUser(props.row)"
                  >
                    <i
                      class="ph ph-trash lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>

  <div
    class="modal fade"
    id="createnewUserModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            {{ isEditing ? "Modifier la ville" : "Nouvelle ville" }}
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitUser">
            <!-- Avatar Upload -->
            <div class="col-md-12 mb-20">
              <label class="d-block text-black fw-semibold mb-10">
                Photo de profil
              </label>
              <div class="d-flex align-items-center">
                <img
                  v-if="imagepreview"
                  :src="imagepreview"
                  class="rounded-circle me-15"
                  style="width: 90px; height: 90px; object-fit: cover"
                />
                <img
                  v-else
                  :src="require('@/assets/images/NoImage.png')"
                  class="rounded-circle me-15"
                  style="width: 90px; height: 90px; object-fit: cover"
                />
                <div>
                  <input
                    ref="updateImgInput"
                    type="file"
                    accept="image/*"
                    class="d-none"
                    @change="logoSelected"
                  />
                  <button
                    type="button"
                    class="btn btn-primary me-2"
                    @click="() => updateImgInput?.click()"
                  >
                    Choisir la photo
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="cancelImage"
                  >
                    Annuler
                  </button>
                </div>
              </div>
            </div>

            <!-- Nom Utilisateur -->
            <div class="form-group mb-3">
              <label for="name">Nom Utilisateur *</label>
              <input
                id="name"
                v-model="newUser.name"
                placeholder="Nom Utilisateur Complet"
                class="form-control"
              />
            </div>

            <!-- Téléphone -->
            <div class="form-group mb-3">
              <label for="phone">Numéro Téléphone *</label>
              <input
                id="phone"
                v-model="newUser.phone"
                placeholder="Numéro Téléphone"
                class="form-control"
              />
            </div>

            <!-- Email -->
            <div class="form-group mb-3">
              <label for="email">Adresse électronique *</label>
              <input
                id="email"
                v-model="newUser.email"
                placeholder="Adresse électronique"
                class="form-control"
              />
            </div>

            <!-- Password -->
            <div class="form-group mb-3">
              <label for="password">Mot de passe *</label>
              <input
                id="password"
                type="password"
                v-model="newUser.password"
                placeholder="Mot de passe"
                class="form-control"
              />
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button type="button" @click="submitUser" class="btn btn-primary">
            {{ isEditing ? "Mettre à jour" : "Enregistrer" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { Modal } from "bootstrap";
export default {
  name: "StaffCustomer",
  props: { userId: { type: String, required: true } },
  setup: (props) => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const newUser = reactive({
      image: null as File | null,
      name: "",
      phone: "",
      email: "",
      password: "",
    });

    const updateImgInput = ref<HTMLInputElement | null>(null);
    const imagepreview = ref<string | null>(null);
    const isEditing = ref(false);
    const headers = [
      {
        label: "Nom Complet",
        field: "name",
      },
      {
        label: "Téléphone",
        field: "phone",
      },
      {
        label: "Email",
        field: "email",
      },
      {
        label: "Date de création",
        field: "created_at",
      },
      {
        label: "Actions",
        field: "actions",
      },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const users = reactive({
      searchName: "",
      searchEmail: "",
      searchDate: "",
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(
          `/api/auth/CustomerUsers?user_id=${props.userId}`,
          {
            params: {
              searchTerm: users.searchTerm,
              searchName: users.searchName,
              searchEmail: users.searchEmail,
              searchDate: users.searchDate,
              page: users.current_page,
              per_page: users.per_page,
            },
          }
        );

        rows.value = res.data.data.data;
        Object.assign(users, res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function openCreateModal() {
      isEditing.value = false;
      resetForm();

      const modalEl = document.getElementById("createnewUserModal");
      if (modalEl) {
        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
        modal.show();
      }
    }

    function openEditModal(city) {
      if (city) {
        isEditing.value = true;
        Object.assign(newUser, city);

        const modalEl = document.getElementById("createnewUserModal");
        if (modalEl) {
          const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
          modal.show();
        }
      }
    }

    function resetForm() {
      Object.assign(newUser, {
        id: null,
        id_zone: "",
        code: "",
        name: "",
        delivered_fees: "",
        retourned_fees: "",
        refused_fees: "",
        delivered_same_city_fees: "",
        delivered_same_zone_fees: "",
        delivered_out_of_zone_fees: "",
      });
    }

    const logoSelected = (e: Event) => {
      const target = e.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        console.log(file);
        newUser.image = file; // use the 'file' variable instead of re-accessing target.files
        imagepreview.value = URL.createObjectURL(file);
      }
    };

    const cancelImage = () => {
      imagepreview.value = null;
      if (updateImgInput.value) updateImgInput.value.value = "";
    };

    async function submitUser() {
      console.log(newUser);
      if (!newUser.email || !newUser.name) {
        showToast("Please fill in all fields!", "error");
        return;
      }
      if (isEditing.value) {
        console.log("edit user")
      } else {
        try {
          let data = new FormData();
          data.append("user_id", user?.id || "");
          data.append("cust_id", props.userId);
          data.append("email", newUser.email);
          data.append("password", newUser.password);
          data.append("phone", newUser.phone);
          data.append("name", newUser.name);
          if (newUser.image) {
            data.append("image", newUser.image);
          }

          const res = await api.post(`/api/auth/NewCustomerUser`, data, {headers: { "Content-Type": "multipart/form-data" }});

          if (res.data.msg === "success") {
            fetchData();
            resetForm();
            const modalEl = document.getElementById("createnewUserModal");
            if (modalEl) {
              const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
              modal.hide();
            }
            showToast("Les données sont bien sauvegardées", "success");
          } else if (res.data.msg === "email exist") {
            showToast("Email existe déjà", "error");
          } else if (res.data.msg === "no customer") {
            showToast("Vous ne pouvez pas ajouter un utilisateur", "error");
          }
        } catch (error) {
          console.error("Erreur lors de l’ajout d’utilisateur :", error);
          showToast("Une erreur est survenue", "error");
        }
      }
    }

    async function destroyUser(row) {
      let data = new FormData();
      data.append("user_id", user?.id);
      data.append("customer_id", row.customer_id);

      Swal.fire({
        text: "Vous voulez supprimer cet utilisateur ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      }).then(async (result) => {
        // make callback async
        if (result.isConfirmed) {
          // use isConfirmed instead of value
          try {
            const res = await api.post(
              `/api/auth/destroyStaff/${row.id}`,
              data
            );
            if (res.data.msg === "success") {
              fetchData();
              showToast("Utilisateur a bien été supprimé", "success");
            } else {
              showToast("Erreur lors de la suppression", "error");
            }
          } catch (error) {
            console.error(error);
            showToast("Erreur serveur", "error");
          }
        }
      });
    }

    return {
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      openEditModal,
      openCreateModal,
      resetForm,
      isEditing,
      submitUser,
      logoSelected,
      cancelImage,
      updateImgInput,
      imagepreview,
      newUser,
      destroyUser,
    };
  },
};
</script>